import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

class RejectModal extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            message: ""
        };
    }

    // LIFECYCLE METHODS
    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
    }

    handleConfirm = () => {
        this.props.handleConfirm(this.state.message);
    }

    handleMessageChange = (event) => {
        this.setState({
            message: event.target.value
        });
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true} onRequestHide={this.handleClose} className="modal fade" id="myModal4" tabIndex="-1" role="dialog" aria-labelledby="myModal4Label" aria-hidden="true">
                <div className="modal-dialog new-log-entry">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myModalLabel">Reject hours</h4>
                        </div>
                        <div className="modal-body">
                            <span>
                                <textarea  className="no-horizontal-resize form-control" ref="nameInput" type="textarea" value={this.state.message} onChange={this.handleMessageChange} placeholder="Rejection message"/>
                            </span>
                        </div>
                        <div className="modal-footer">
                            <button title="Reject hours with message" ref="createButton" type="button" className="btn btn-default btn-large" onClick={this.handleConfirm}>Reject</button>
                            <button title="Cancel rejection" ref="closeButton" type="button" className="btn btn-default btn-discrete" onClick={this.handleClose}>Cancel</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

RejectModal.propTypes = {
    handleConfirm: PropTypes.func,
    handleClose: PropTypes.func
};

export default connect()(RejectModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/RejectModal.js
 **/